<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#3ea56e"
      size="128"
      is-full-screen
    />
    <v-snackbar v-model="showsnackbar" color="#3ea56e" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <div v-else class="add-product-page">
      <!-- Page Header -->
      <div class="page-header">
        <div class="page-title-group">
          <v-icon class="page-title-icon">mdi-account-edit</v-icon>
          <div>
            <h1 class="page-title">Edit User Profile</h1>
          </div>
        </div>
      </div>

      <!-- Form Body -->
      <div class="form-body">
        <v-form ref="profileForm" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="12" class="form-left-col">
              
              <!-- 01 Personal Information -->
              <div class="form-section">
                <div class="section-header">
                  <span class="section-number">01</span>
                  <div>
                    <h2 class="section-title">Personal Information</h2>
                  </div>
                </div>
                <div class="section-body">
                  <v-row>
                    <v-col cols="12" sm="6">
                      <div class="field-group">
                        <label class="field-label">First Name</label>
                        <v-text-field
                          :rules="nameRules"
                          v-model="firstname"
                          color="#4CAF50"
                          outlined dense hide-details
                          placeholder="First Name"
                          prepend-inner-icon="mdi-account"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <div class="field-group">
                        <label class="field-label">Last Name</label>
                        <v-text-field
                          :rules="nameRules"
                          v-model="lastname"
                          color="#4CAF50"
                          outlined dense hide-details
                          placeholder="Last Name"
                          prepend-inner-icon="mdi-account-outline"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <div class="field-group">
                        <label class="field-label">Username</label>
                        <v-text-field
                          :rules="nameRules"
                          v-model="username"
                          color="#4CAF50"
                          outlined dense hide-details
                          placeholder="Username"
                          prepend-inner-icon="mdi-badge-account-horizontal"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <div class="field-group">
                        <label class="field-label">Account Type</label>
                        <v-text-field
                          :rules="Rules"
                          v-model="accounttype"
                          color="#4CAF50"
                          outlined dense hide-details
                          placeholder="Account Type"
                          prepend-inner-icon="mdi-card-account-details"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>

              <!-- 02 Contact Information -->
              <div class="form-section">
                <div class="section-header">
                  <span class="section-number">02</span>
                  <div>
                    <h2 class="section-title">Contact Information</h2>
                  </div>
                </div>
                <div class="section-body">
                  <v-row>
                    <v-col cols="12" sm="4">
                      <div class="field-group">
                        <label class="field-label">Email</label>
                        <v-text-field
                          :rules="emailRules"
                          v-model="email"
                          color="#4CAF50"
                          outlined dense hide-details
                          placeholder="Email"
                          prepend-inner-icon="mdi-email"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <div class="field-group">
                        <label class="field-label">Phone</label>
                        <v-text-field
                          :rules="phoneRules"
                          v-model="phone"
                          color="#4CAF50"
                          outlined dense hide-details
                          placeholder="Phone Number"
                          prepend-inner-icon="mdi-phone"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <div class="field-group">
                        <label class="field-label">Country</label>
                        <v-text-field
                          :rules="Rules"
                          v-model="country"
                          color="#4CAF50"
                          outlined dense hide-details
                          placeholder="Country"
                          prepend-inner-icon="mdi-earth"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>

              <v-row class="mt-4 pb-12">
                <v-col cols="12" sm="6">
                  <v-btn block large depressed @click="$router.go(-1)" style="border-radius: 8px; border: 1px solid #dde3ea;">Cancel</v-btn>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-btn 
                    block large dark depressed 
                    color="#4CAF50" 
                    class="submit-btn text-capitalize" 
                    :ripple="false" 
                    :disabled="!valid"
                    @click="validate()">
                    <v-icon left>mdi-check-circle</v-icon>
                    Save Changes
                  </v-btn>
                </v-col>
              </v-row>

            </v-col>
          </v-row>
        </v-form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: ["userid"],
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showsnackbar: false,
      firstname: null,
      lastname: null,
      username: null,
      accounttype: null,
      country: null,
      phone: null,
      email: null,
      type: null,
      msg: null,
      valid: true,
      Rules: [(v) => !!v || "Required"],
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 15) || "Name must be less than 15 characters",
      ],
      emailRules: [
        (v) => !!v || "Email is Required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      phoneRules: [
        (v) => !!v || "Phone Number is Required",
        (v) => (v && v.length <= 10) || "Number must be less than 11",
        (v) => (v && v.length >= 10) || "Number must be grater than 10",
        (v) => /^\d{10}$/.test(v) || "Phone must be number",
      ],
    };
  },
  mounted: function() {
    this.getData();
  },
  methods: {
    validate() {
      if (this.$refs.profileForm.validate()) {
        this.editUser();
      }
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/user/info",
        method: "GET",
        params: {
          id: this.$route.query.user,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          var user = response.data.data;
          this.firstname = user.firstname;
          this.lastname = user.lastname;
          this.username = user.username;
          this.phone = user.phone;
          this.email = user.email;
          this.type = user.type;
          this.accounttype = user.accounttype;
          this.country = user.country;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    editUser() {
      this.appLoading = true;
      var user = {};
      user["firstname"] = this.firstname;
      user["lastname"] = this.lastname;
      user["username"] = this.username;
      user["phone"] = this.phone;
      user["email"] = this.email;
      user["type"] = this.type;
      user["accounttype"] = this.accounttype;
      user["country"] = this.country;
      user["id"] = this.$route.query.user;
      axios({
        method: "POST",
        url: "/user/AdminEdit",

        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: user,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Updated Sucessfully";
            this.showsnackbar = true;
            this.getData();
            this.$router.go(-1);
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
  },
};
</script>
<style scoped>
/* ── Page Shell ─────────────────────────────── */
.add-product-page {
  min-height: 100vh;
  background: #f6f8fb;
}

/* ── Page Header ────────────────────────────── */
.page-header {
  background: #ffffff;
  border-bottom: 1px solid #e8ecf0;
  padding: 20px 28px;
  position: sticky;
  top: 0;
  z-index: 2;
}
.page-title-group {
  display: flex;
  align-items: center;
  gap: 14px;
}
.page-title-icon {
  font-size: 28px !important;
  color: #4caf50;
}
.page-title {
  font-family: poppinssemibold, sans-serif;
  font-size: 20px;
  color: #1c1c1c;
  margin: 0;
  line-height: 1.2;
}

/* ── Form Body ──────────────────────────────── */
.form-body {
  max-width: 1400px;
  margin: 0 auto;
  padding: 24px 20px 48px;
}
.form-left-col {
  padding-right: 0;
}
@media (min-width: 1264px) {
  .form-left-col { padding-right: 20px; }
}

/* ── Section Cards ──────────────────────────── */
.form-section {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e8ecf0;
  margin-bottom: 20px;
  overflow: hidden;
  transition: box-shadow 0.2s ease;
}
.form-section:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
}
.section-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 18px 24px;
  border-bottom: 1px solid #f0f3f7;
  background: #fafbfc;
}
.section-number {
  font-family: poppinssemibold, sans-serif;
  font-size: 22px;
  color: #d0d8e4;
  line-height: 1;
  min-width: 36px;
}
.section-title {
  font-family: poppinssemibold, sans-serif;
  font-size: 15px;
  color: #1c1c1c;
  margin: 0;
}
.section-body { padding: 20px 24px; }

/* ── Fields ─────────────────────────────────── */
.field-group { margin-bottom: 4px; }
.field-label {
  display: block;
  font-family: poppinssemibold, sans-serif;
  font-size: 12px;
  color: #555;
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

/* ── Inputs ─────────────────────────────────── */
.modern-input >>> .v-input__slot {
  border-radius: 8px !important;
  min-height: 40px;
  background: #fdfdfd;
}
.modern-input >>> fieldset { border-color: #dde3ea !important; }
.modern-input:hover >>> fieldset { border-color: #4caf50 !important; }

/* ── Submit Button ──────────────────────────── */
.submit-btn {
  border-radius: 8px !important;
  font-family: poppinssemibold, sans-serif !important;
  font-size: 14px !important;
  letter-spacing: 0.5px;
  height: 48px !important;
  background: linear-gradient(135deg, #43a047, #66bb6a) !important;
  box-shadow: 0 4px 14px rgba(76, 175, 80, 0.35) !important;
  transition: box-shadow 0.2s ease, transform 0.15s ease !important;
}
.submit-btn:hover {
  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.45) !important;
  transform: translateY(-1px);
}

/* ── Responsive ─────────────────────────────── */
@media (max-width: 960px) {
  .form-body { padding: 16px 12px 40px; }
  .section-header { padding: 14px 16px; }
  .section-body { padding: 14px 16px; }
  .page-header { padding: 14px 16px; }
}
@media (max-width: 600px) {
  .section-number { font-size: 16px; min-width: 28px; }
  .section-title { font-size: 14px; }
}
</style>
